module.exports = __webpack_public_path__ + "static/media/logo1.fc3bef55.png";